// extracted by mini-css-extract-plugin
export var full_screen_video = "styles-module--full_screen_video--becb1";
export var full_screen_video__content = "styles-module--full_screen_video__content--376dc";
export var full_screen_video__play_button = "styles-module--full_screen_video__play_button--18efd";
export var full_screen_video__play_button_triangle = "styles-module--full_screen_video__play_button_triangle--65bbe";